export default "__VITE_ASSET__B81Zm8j1__"